<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex
                    xs12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="quotation.name"
                        label="Name"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="quotation.reference_number"
                        label="Reference number"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    md3
                >
                    <v-currency-field
                        class="title-branding custom-input"
                        label="Premium"
                        v-model="quotation.total_premium"
                        v-bind="$root.currency_config"
                        type="tel"
                        filled
                        readonly
                    ></v-currency-field>
                </v-flex>

                <v-flex
                    xs12
                    md3
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="quotation.selected_lpp_label"
                        label="Selected LPP™"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    md3
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="quotation.version"
                        label="Version"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    md3
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="quotation.iteration"
                        label="Iteration"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>


                <v-flex
                    xs12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        :value="quotation.cl_user.first_name + ' ' + quotation.cl_user.last_name"
                        label="Created By"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        :value="quotation.intermediary.FirstName + ' ' + quotation.intermediary.LastName"
                        label="Intermediary"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

            </v-layout>
        </v-card-text>

        <v-card-actions>
<!--            <v-btn-->
<!--                class="custom-button"-->
<!--                type="button"-->
<!--                color="secondary"-->
<!--                v-if="homeVantageQuote"-->
<!--                @click="createDealMakerApplication"-->
<!--                :small="isMobile"-->
<!--                :loading="creating_dealmaker_application"-->
<!--                :disabled="requesting_pdf || requesting_new_version"-->
<!--            >-->
<!--                Create Dealmaker application-->
<!--            </v-btn>-->
            <v-spacer></v-spacer>
<!--            <v-btn-->
<!--                v-if="!notAllowedToCreateNewVersion"-->
<!--                class="custom-button"-->
<!--                type="button"-->
<!--                color="accent"-->
<!--                @click="newVersion"-->
<!--                :loading="requesting_new_version"-->
<!--                :disabled="requesting_pdf || creating_dealmaker_application"-->
<!--                :small="isMobile"-->
<!--            >-->
<!--                New version-->
<!--            </v-btn>-->
            <v-btn
                class="custom-button"
                type="button"
                :color="$vuetify.theme.dark ? 'primary lighten-1' : 'primary'"
                @click="viewPdf"
                :loading="requesting_pdf"
                :disabled="requesting_new_version || creating_dealmaker_application"
                :small="isMobile"
            >
                View PDF
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                quotation: {},

                requesting_pdf: false,
                requesting_new_version: false,
                creating_dealmaker_application: false,
            }
        },
        props: ['itemInfo'],
        name: 'Quotation-Info',
        mounted() {
            this.quotation = this.itemInfo;
            setTimeout(() => {
                this.loading = false;
            }, 100);
        },

        computed: {
            notAllowedToCreateNewVersion() {
                let url = new window.domurl;

                return typeof url.query.hnv !== 'undefined' && url.query.hnv === 'true';
            },
            homeVantageQuote() {
                return this.quotation.type === 2;
            }
        },

        methods: {
            viewPdf() {
                this.requesting_pdf = true;

                this.createNewBrowserTab();

                window.axios.post('/calculators/quotationPdf', {
                    quote_id: this.quotation.id,
                })
                    .then((response) => {
                        if (typeof response.data.url !== 'undefined') {
                            this.openUrlInNewTab(response.data.url);
                        }

                        this.requesting_pdf = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.requesting_pdf = false;
                    });
            },

            newVersion() {
                this.requesting_new_version = true;

                window.axios.post('/quotations/newVersion', {
                    quote_id: this.quotation.id,
                })
                    .then((response) => {


                        if (this.quotation.type === 1) {
                            this.createQuoteFromData({
                                type: 'mycover',
                                version: response.data.quotation.id,
                                client_name: response.data.quotation.client.name,
                            });
                        }

                        if (this.quotation.type === 2) {
                            this.createQuoteFromData({
                                type: 'homevantage',
                                version: response.data.quotation.id,
                                client_name: response.data.quotation.client.name,
                            });
                        }


                        this.requesting_new_version = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.requesting_new_version = false;
                    });
            },

            createDealMakerApplication() {
                this.creating_dealmaker_application = true;

                window.axios.post('/applications/create', {
                    id: this.quotation.id,
                })
                    .then((response) => {
                        this.$router.push('/applications/edit/' + response.data.application.id + '?tab=information');

                        this.requesting_new_version = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.requesting_new_version = false;
                    });
            }
        }
    }
</script>
